import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { COMPANY } from "@/lib/site";
import { Reveal } from "./Reveal";

export const CTABand = ({
    title = "Thinking About Switching to a Heat Pump?",
    text = "Tell us a little about your property and our team can discuss your heating requirements and the next steps.",
    primaryLabel = "Get My Free Assessment",
    primaryTo = "/contact#enquiry-form",
}) => (
    <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <div className="relative overflow-hidden rounded-3xl bg-slate-950 px-6 py-14 text-center md:px-14 md:py-20">
                    <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-emerald-600/20 blur-3xl" />
                    <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-emerald-500/10 blur-3xl" />
                    <h2 className="relative mx-auto max-w-2xl font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
                        {title}
                    </h2>
                    <p className="relative mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-400">{text}</p>
                    <div className="relative mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                        <Link
                            to={primaryTo}
                            data-testid="cta-band-primary-button"
                            className="group flex w-full items-center justify-center gap-2 rounded-full bg-emerald-600 px-7 py-3.5 text-sm font-semibold text-white shadow-lg shadow-emerald-600/25 transition-colors duration-200 hover:bg-emerald-500 sm:w-auto"
                        >
                            {primaryLabel}
                            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
                        </Link>
                        <a
                            href={COMPANY.phoneHref}
                            data-testid="cta-band-call-button"
                            className="flex w-full items-center justify-center gap-2 rounded-full border border-slate-700 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:border-emerald-500 hover:text-emerald-400 sm:w-auto"
                        >
                            <Phone className="h-4 w-4" /> Call {COMPANY.phoneDisplay}
                        </a>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
